
export default function Workflow() {
  const steps = [
    {
      title: 'Import your data',
      image: '/assets/images/workflow-import.gif'
    },
    {
      title: 'Get insight with AI empowered data profiling',
      image: '/assets/images/workflow-insight.gif'
    },
    {
      title: 'Explore, wrangle, clean and reshape',
      image: '/assets/images/workflow-clean.gif'
    },
    {
      title: 'Save your Workflow',
      image: '/assets/images/workflow-save.gif'
    },
    {
      title: 'Share New Dataset',
      image: '/assets/images/workflow-share.gif'
    }
  ];

  return (
    <section className="bg-gray-50 py-20">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center mb-4">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Faster. Simpler. Better.
          </h2>
          <p className="text-lg text-gray-600">
            Save your Workflows and next time allow Bumblebee to clean the data for you.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mt-16">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="relative mb-4 w-full">
                <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 aspect-[4/3]">
                  <img 
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-arrow-right-line text-white text-sm"></i>
                </div>
              </div>
              <p className="text-sm text-gray-700 mt-4 leading-snug">
                {step.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
